export default __webpack_public_path__ + "static/media/siesOpen.dc24a4e7.jpg";